(function () {
  if (window.__hgCartInit) return;
  window.__hgCartInit = true;

  var SECTION = 'hagen-cart';
  var SECTION_DR = 'hagen-cart-desktop';
  var ROOTS = '#HgCartRoot, #HgDrRoot';
  // Hvor lang tid der ventes efter sidste klik paa +/- foer ændringen sendes.
  // Flere hurtige klik samles dermed til én opdatering.
  var QTY_DELAY = 150;

  function drRoot() {
    return document.getElementById('HgDrRoot');
  }

  function root() {
    return drRoot();
  }

  function visible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  function openCart() {
    var r = root();
    if (!r) return;
    r.classList.add('is-open');
    document.documentElement.classList.add('hg-cart-open');
    var panels = r.querySelectorAll('[data-hg-cart-panel], .hg-cart__modal');
    for (var i = 0; i < panels.length; i++) {
      if (visible(panels[i])) { try { panels[i].focus({ preventScroll: true }); } catch (err) {} break; }
    }
  }

  function closeCart() {
    document.querySelectorAll(ROOTS).forEach(function (r) { r.classList.remove('is-open'); });
    document.documentElement.classList.remove('hg-cart-open');
  }

  function isOpener(el) {
    if (!el || !el.closest) return false;
    if (el.closest(ROOTS)) return false;
    if (el.closest('[data-hg-cart-open]')) return true;
    var a = el.closest('a');
    if (a) {
      var href = a.getAttribute('href') || '';
      if (/\/cart(\/?$|\?)/.test(href)) return true;
    }
    var node = el.closest('a, button, [role="button"]');
    if (node && node.querySelector('[data-hg-cart-count]')) return true;
    return false;
  }

  function updateCartLinks(count) {
    if (count === null || count === undefined) return;

    var slots = document.querySelectorAll('[data-hg-cart-count]');
    var wrote = false;
    slots.forEach(function (el) {
      if (el.closest(ROOTS)) return;
      el.textContent = count;
      wrote = true;
    });

    if (wrote) return;

    document.querySelectorAll('a, button, [role="button"]').forEach(function (el) {
      if (el.closest(ROOTS)) return;
      if (el.children.length) return;
      var txt = el.textContent || '';
      if (!/cart|kurv|bag/i.test(txt)) return;
      if (!/\(\s*\d+\s*\)/.test(txt)) return;
      el.textContent = txt.replace(/\(\s*\d+\s*\)/, '(' + count + ')');
    });
  }

  function swapRoot(html, id) {
    if (!html) return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById(id);
    var cur = document.getElementById(id);
    if (!fresh || !cur) return null;
    var wasOpen = cur.classList.contains('is-open');
    cur.innerHTML = fresh.innerHTML;
    cur.setAttribute('data-count', fresh.getAttribute('data-count'));
    return { wasOpen: wasOpen, count: fresh.getAttribute('data-count') };
  }

  function sectionsParam() {
    return SECTION + (drRoot() ? ',' + SECTION_DR : '');
  }

  // Saetter de nye sektioner ind. Returnerer { wasOpen, count } eller null.
  function applySections(data) {
    if (!data) return null;
    var a = swapRoot(data[SECTION], 'HgCartRoot');
    var b = swapRoot(data[SECTION_DR], 'HgDrRoot');
    var res = a || b;
    if (!res) return null;
    updateCartLinks(res.count);
    return { wasOpen: (a && a.wasOpen) || (b && b.wasOpen), count: res.count };
  }

  function refresh(openAfter) {
    var url = window.location.pathname + '?sections=' + sectionsParam();
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var res = applySections(data);
        if (!res) return;
        if (res.wasOpen || openAfter) openCart();
      })
      .catch(function () { if (openAfter) openCart(); });
  }

  /*
    Ét kald til /cart/change.js, der også returnerer de opdaterede kurv-sektioner.
    canSwap() afgør (når svaret kommer) om kurven må tegnes om. Hvis brugeren
    imens har trykket igen, springer vi tegningen over, så tallet ikke hopper.
  */
  function changeLine(line, quantity, canSwap) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: Number(line),
        quantity: Number(quantity),
        sections: sectionsParam(),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && typeof cart.item_count !== 'undefined') updateCartLinks(cart.item_count);
        var allowed = !canSwap || canSwap();
        if (cart && cart.sections) {
          if (allowed) applySections(cart.sections);
          return;
        }
        if (allowed) return refresh(false);
      })
      .catch(function () { return refresh(false); });
  }

  function removeLine(line) {
    return changeLine(line, 0);
  }

  // Sender kun det sidste valgte antal pr. linje, efter en kort pause.
  var qtyState = {};

  function queueQty(line, qty, immediate) {
    var st = qtyState[line] || (qtyState[line] = { target: qty, busy: false, timer: null });
    st.target = qty;
    clearTimeout(st.timer);
    st.timer = setTimeout(function () { flushQty(line); }, immediate ? 0 : QTY_DELAY);
  }

  function flushQty(line) {
    var st = qtyState[line];
    if (!st) return;
    if (st.busy) return; // sendes igen når det nuværende kald er færdigt
    st.busy = true;
    var sending = st.target;
    changeLine(line, sending, function () { return st.target === sending; }).then(function () {
      st.busy = false;
      if (st.target !== sending) {
        flushQty(line);
      } else {
        delete qtyState[line];
      }
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-hg-cart-close]')) { e.preventDefault(); closeCart(); return; }
    if (t.closest('[data-hg-cart-overlay]')) { e.preventDefault(); closeCart(); return; }

    var rm = t.closest('[data-hg-cart-remove]');
    if (rm) { e.preventDefault(); rm.setAttribute('disabled', ''); removeLine(rm.getAttribute('data-line')); return; }

    var step = t.closest('[data-hg-qty-step]');
    if (step) {
      e.preventDefault();
      var box = step.closest('[data-hg-qty]');
      if (!box || step.hasAttribute('disabled')) return;
      var cur = parseInt(box.getAttribute('data-qty'), 10);
      if (isNaN(cur)) cur = 1;
      var min = parseInt(box.getAttribute('data-min'), 10);
      if (isNaN(min)) min = 0;
      var next = cur + parseInt(step.getAttribute('data-hg-qty-step'), 10);
      if (next < min) return;

      // Vis det nye tal med det samme (uden at vente paa serveren)
      box.setAttribute('data-qty', next);
      var val = box.querySelector('.hg-dr__qval');
      if (val && next > 0) val.textContent = next;
      if (min >= 1) {
        var minus = box.querySelector('[data-hg-qty-step="-1"]');
        if (minus) {
          if (next <= min) minus.setAttribute('disabled', '');
          else minus.removeAttribute('disabled');
        }
      }
      if (next === 0) {
        var item = box.closest('.hg-dr__item');
        if (item) item.style.opacity = '0.4';
      }

      queueQty(box.getAttribute('data-line'), next, next === 0);
      return;
    }

    if (t.closest(ROOTS)) return;

    if (isOpener(t) && root()) { e.preventDefault(); e.stopPropagation(); refresh(true); }
  }, true);

  /*
    The product section adds to the cart itself and then fires
    'hagen:cart-updated'. We must NOT add a second time — that was the
    double-add bug. So: forms that are handled elsewhere are left alone,
    and we only react to the event.
  */
  document.addEventListener('hagen:cart-updated', function (e) {
    var count = e && e.detail ? e.detail.count : undefined;
    if (typeof count !== 'undefined') updateCartLinks(count);
    refresh(true);
  });

  function handledElsewhere(form) {
    return !!(
      form.classList.contains('hg-p-form') ||
      form.hasAttribute('data-hg-own-add') ||
      form.closest('.hg-product')
    );
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (!root()) return;
    if (handledElsewhere(form)) return;

    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function () { return refresh(true); })
      .catch(function () {})
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  function boot() {
    var r = document.getElementById('HgCartRoot') || drRoot();
    if (r) updateCartLinks(r.getAttribute('data-count'));
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
